import Visible from '@portalterreno/react-ui/Visible';
import { useRouter } from 'next/router';
import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { reset } from '../../redux/slices/showPhoneForm';
import { RootState } from '../../redux/store';
import ShowPhoneModalForm, { ShowPhoneFormProps } from '../ShowPhoneForm';
import AllWidthDiv from './AllWidthDiv';
import ContentWrapper from './ContentWrapper';
import FlexDiv from './FlexDiv';
import DesktopPhoneButton from './PhoneButton/DesktopPhoneButton';
import MobilePhoneButton from './PhoneButton/MobilePhoneButton';
import PhoneChip from './PhoneChip';
import StyledDivider from './PhoneChip/StyledDivider';
import PublishedByContent, {
  PublishedByContentProps
} from './PublishedByContent';
import StyledAnchor from './StyledAnchor';
import StyledWrapper from './StyledWrapper';

export type SellerInformationProps = React.HTMLAttributes<HTMLDivElement> &
  Pick<PublishedByContentProps, 'sellerLogo' | 'sellerName'> &
  Partial<ShowPhoneFormProps> & {
    brokerLandingUrl?: string;
    sellerPhone?: string | null;
  };

const SellerInformation: React.FC<SellerInformationProps> = ({
  brokerLandingUrl,
  sellerName,
  sellerLogo,
  sellerPhone,
  onSubmit,
  ...rest
}) => {
  const { isPhoneDisplayed } = useSelector(
    (state: RootState) => ({
      isPhoneDisplayed: state.showPhoneForm.isPhoneDisplayed
    }),
    shallowEqual
  );
  const dispatch = useDispatch();
  const router = useRouter();

  React.useEffect(() => {
    const dispatchReset = () => {
      dispatch(reset());
    };
    router.events.on('routeChangeComplete', dispatchReset);

    return () => {
      router.events.off('routeChangeComplete', dispatchReset);
    };
  });

  return (
    <AllWidthDiv {...rest}>
      <StyledWrapper>
        <FlexDiv>
          <ContentWrapper>
            {brokerLandingUrl ? (
              <StyledAnchor href={brokerLandingUrl}>
                <PublishedByContent
                  sellerLogo={sellerLogo}
                  sellerName={sellerName}
                />
              </StyledAnchor>
            ) : (
              <PublishedByContent
                sellerLogo={sellerLogo}
                sellerName={sellerName}
              />
            )}

            {sellerPhone && (
              <Visible desktop>
                <DesktopPhoneButton />
              </Visible>
            )}
          </ContentWrapper>
        </FlexDiv>
        {!isPhoneDisplayed && sellerPhone && (
          <Visible mobile>
            <MobilePhoneButton />
          </Visible>
        )}

        {isPhoneDisplayed && sellerPhone && (
          <React.Fragment>
            <StyledDivider />
            <PhoneChip>{sellerPhone}</PhoneChip>
          </React.Fragment>
        )}
      </StyledWrapper>
      {sellerPhone && onSubmit && <ShowPhoneModalForm onSubmit={onSubmit} />}
    </AllWidthDiv>
  );
};

export default React.memo(SellerInformation);
